import { FunctionComponent, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { loginWebPush } from './push/webPush'
import { IAlphaprocessState } from './store'

// links this device's web push subscription to the logged in user
const OneSignalSetup: FunctionComponent = () => {
  const userId = useSelector((state: IAlphaprocessState) => state.core.user?.id)

  useEffect(() => {
    if (userId) loginWebPush(userId)
  }, [userId])

  return null
}

export default OneSignalSetup
